import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useDropzone } from 'react-dropzone';

import Image from '../image';
import { getBase64 } from '../../helpers/file';
import { useState } from 'react';

const DropZoneStyle = styled('div')(({ theme }) => ({
    outline: 'none',
    overflow: 'hidden',
    position: 'relative',
    padding: theme.spacing(5, 1),
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('padding'),
    backgroundColor: theme.palette.grey[200],
    border: `1px dashed ${theme.palette.grey[500]}`,
    '&:hover': { opacity: 0.72, cursor: 'pointer' },
}));

interface Props {
    file?: string | object,
    selectedFile?: File,
    title?: string,
    onChange: (fileBase64: string, file: File) => void,
}

export const Dropzone: React.FC<Props> = ({ title = 'Drop or Select file',file, selectedFile, onChange }) => {
    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
        multiple: false,
    });

    return (
        <Box sx={{ width: '100%' }}>
            <DropZoneStyle
                {...getRootProps()}
                sx={{
                    ...(isDragActive && { opacity: 0.72 }),
                    ...((isDragReject) && {
                        color: 'error.main',
                        borderColor: 'error.light',
                        bgcolor: 'error.lighter',
                    }),
                    ...(file && {
                        padding: '12% 0',
                    }),
                }}
                
                onChange={async e => {
                    const file = (e.target as any).files[0] as File;
                    const fileBase64 = await getBase64(file);
                    onChange(fileBase64, file);
                }}
            >
                    <input {...getInputProps()} />

                    <Stack
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                        alignContent={'center'}
                        direction={{ xs: 'column', md: 'row' }}
                        sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
                    >
                        <Box 
                            display={'flex'}
                            flexDirection={'column'}
                            sx={{ p: 3 }}
                            alignItems="center"
                            justifyContent="center"
                            alignContent={'center'}
                        >
                            {file && <img src="/static/illustrations/file_uploaded.svg" style={{ width: 124, height: 48, marginBottom: 20 }} />}
                            {!file && <img src="/static/illustrations/upload_file.svg" style={{ width: 124, height: 48, marginBottom: 20 }} />}

                            <Typography fontWeight={500} gutterBottom variant="h5" textAlign={'center'}>
                                {!file ? title : 'File Selected'}
                            </Typography>
                            {!file &&
                                <Typography variant="body2" sx={{ color: 'text.secondary' }} textAlign={'center'}>
                                    Drop files here or click to&nbsp;
                                    <Typography
                                        variant="body2"
                                        component="span"
                                        sx={{ color: 'primary.main', textDecoration: 'underline' }}
                                    >
                                        browse
                                    </Typography>
                                    &nbsp;in your machine
                                </Typography>
                            }
                            {file &&
                                <Typography fontWeight={400} textAlign={'center'} variant="body2" sx={{ color: 'text.secondary' }}>
                                    <strong>{selectedFile?.name}</strong> selected, if you want to change, just click here again.
                                </Typography>
                            }
                           
                        </Box>
                    </Stack>

                    {file && selectedFile?.type === 'image/png' && (
                        <Image
                            disabledEffect={false}
                            alt="file preview"
                            src={typeof file === 'string' ? file : (file as any)?.preview}
                            sx={{
                                top: 8,
                                left: 8,
                                borderRadius: 1,
                                position: 'absolute',
                                width: 'calc(100% - 16px)',
                                height: 'calc(100% - 16px)',
                            }}
                        />
                    )}
                </DropZoneStyle>
        </Box>
    )
}